import { types } from 'mobx-state-tree';

import mandatoryId from 'utils/store/mandatoryId';

export const FireConfigModel = types.model('FireConfigModel', {
  id: types.identifierNumber,
  strategy_setting_type: types.maybe(types.string),
  default_config: types.maybe(types.boolean),
});

export const createFireConfigModel = (data?: any): FireConfigModelType => {
  return {
    id: mandatoryId(data?.id),
    strategy_setting_type: data?.strategy_setting_type || undefined,
    default_config: data?.default_config || undefined,
  };
};

export type FireConfigModelType = typeof FireConfigModel.Type;
export default FireConfigModel;
